import { Fragment, useState } from "react";

import classes from "./DrinkContentsPage.module.css";

import DrinkReferenceLine from "./DrinkReferenceLine/DrinkRefernceLine";

// component for contents page in book showing cocktails
const DrinkContentsPage = (props) => {
  const [showDeleteButton, setShowDeleteButton] = useState(false);

  const drinks = props.drinks;

  // map each cocktail in book to a contents page line
  const drinkReferences = drinks.map((drink, index) => {
    return <DrinkReferenceLine key={index} drink={drink} pageNum={index + 1} />;
  });

  // toggle the option to delete the book
  const toggleDeleteButtonHandler = () => {
    setShowDeleteButton(!showDeleteButton);
  };

  // delete the book from local storage
  const deleteBookHandler = () => {
    console.log("running lower delete");
    props.deleteBook();
  };

  return (
    <div className={classes.contents_page}>
      <div className={classes.header}>
        <div className={classes.page}>PAGE</div>
        <div className={classes.title}>DRINK</div>
        <div className={classes.quantity}>QUANTITY</div>
      </div>
      <div className={classes.line_separator} />
      <div className={classes.body}>{drinkReferences}</div>

      <div className={classes.footer}>
        {/* <div
          className={classes.toggle_delete_button}
          onClick={toggleDeleteButtonHandler}
        >
          {!showDeleteButton ? (
            "DELETE BOOK"
          ) : (
            <Fragment>
              <div className={classes.delete_button_yes} onClick={deleteBookHandler}>DELETE</div>
              |
              <div className={classes.delete_button_no}>BACK</div>
            </Fragment>
          )}
        </div>
      </div> */}
        {!showDeleteButton ? (
          <div
            className={classes.toggle_delete_button}
            onClick={toggleDeleteButtonHandler}
          >
            DELETE BOOK
          </div>
        ) : (
          <Fragment>
            <div
              className={classes.toggle_delete_button}
              onClick={deleteBookHandler}
            >
              DELETE
            </div>

            <div className={classes.toggle_back_button} onClick={toggleDeleteButtonHandler}>BACK</div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default DrinkContentsPage;
